document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-showHide').forEach(initComponent);

    document.body.addEventListener('click', e => {
        if (!e.target.matches('.show-more-btn')) return;

        const component = e.target.closest('.c-showHide');
        if (!component) return;

        toggleItems(component);
    });
});

const initComponent = component => {
    const container = component.querySelector('[data-content-container="true"]');
    updateVisibility(container);
    setInitialMaxHeight(container);
    updateButtonVisibility(component);
};

const setInitialMaxHeight = container => {
    const maxHeight = container.closest('.c-showHide').getAttribute('data-max-height');
    if (!maxHeight) return;

    container.style.maxHeight = `${maxHeight}px`;
    container.style.overflowY = 'hidden';
};

const updateVisibility = container => {
    const showInitial = parseInt(container.closest('.c-showHide').getAttribute('data-show-initial'), 10);
    [...container.children].forEach((item, index) => {
        if (index < showInitial && item.style.display) {
            item.removeAttribute('style');
            return;
        }

        if (index >= showInitial) {
            item.style.display = 'none';
        }
    });
};

const toggleItems = component => {
    const container = component.querySelector('[data-content-container="true"]');
    const isExpanded = component.classList.contains('expanded');

    component.classList.toggle('expanded', !isExpanded);

    if (!isExpanded) {
        expandItems(container);
        updateButtonVisibility(component);
        return;
    }

    collapseItems(component, container);
    updateButtonVisibility(component);
};

const expandItems = container => {
    container.style.maxHeight = 'none';
    [...container.children].forEach(item => item.style.display = '');
    cleanUpStyleAttributes(container, true);
};

const collapseItems = (component, container) => {
    const showInitial = parseInt(component.getAttribute('data-show-initial'), 10);
    [...container.children].forEach((item, index) => item.style.display = index < showInitial ? '' : 'none');
    const maxHeight = component.getAttribute('data-max-height');
    container.style.maxHeight = maxHeight ? `${maxHeight}px` : '';
    cleanUpStyleAttributes(container, false);
};

const cleanUpStyleAttributes = (container, isExpanding) => {
    if (isExpanding && container.style.maxHeight === 'none') {
        container.removeAttribute('style');
    }

    [...container.children].forEach(item => {
        if (item.style.display === '') {
            item.removeAttribute('style');
        }
    });
};

const updateButtonVisibility = component => {
    const container = component.querySelector('[data-content-container="true"]');
    const button = component.querySelector('.show-more-btn');
    const isExpanded = component.classList.contains('expanded');
    const showLess = component.getAttribute('data-show-less') === 'true';
    const showMoreText = component.getAttribute('data-show-more-text') || 'Show More';
    const showLessText = component.getAttribute('data-show-less-text') || 'Show Less';

    button.textContent = isExpanded ? showLessText : showMoreText;

    if (!showLess && isExpanded) {
        button.style.display = 'none';
        container.removeAttribute('style');
        return;
    }

    button.style.display = '';

    if (button.style.display === '') {
        button.removeAttribute('style');
    }
};
